<template>
  <div class="smAi">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <!-- <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>

        <el-input v-if="radio == '条件查询'" placeholder="机构,商户,备注" v-model="merInputVal" size="medium"
          style="width: 310px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>

        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
 -->
      </div>
      <div class="x-flex">
        <el-button type="danger" size="medium" @click="fMsgAdd">增加消息</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 164px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column type="seq" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :min-width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
              </div>
            </template>
          </vxe-column>

          <vxe-column fixed="right" title="操作" width="60" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-flex x-row-around">
                <!-- <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-r-10" style="color: #2c8ff2">
                  修改
                </el-button> -->
                <el-button type="text" size="mini" @click="unBand(scope.row)" style="color: #2c8ff2">
                  删除
                </el-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <!-- <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination> -->
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditAgent" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="8vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">
          {{ msgAddOrEdit == "ADD" ? "增加消息" : "修改消息" }}
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSavesmAi">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 软件信息  AI编码-->
      <div class="x-flex">

        <div class="x-flex x-p-t-20 x-p-r-20">
          <!-- <div class="x-flex x-flex-1"> -->
          <div class="x-p-r-10 x-text-r x-w100">
            软件信息
          </div>
          <div class="x-flex-1">
            <el-select v-model="msgInfo.soft_type" placeholder="请选择">
              <el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val">
              </el-option>
            </el-select>
          </div>
          <!-- </div> -->
        </div>
        <div class="x-flex x-p-t-20 x-p-r-20">
          <!-- <div class="x-flex x-flex-1"> -->
          <div class="x-p-r-10 x-text-r x-w100">
            消息类型
          </div>
          <div class="x-flex-1">
            <el-select v-model="msgInfo.msg_type" placeholder="请选择">
              <el-option v-for="item in msgTypeList" :key="item.val" :label="item.val" :value="item.val">
              </el-option>
            </el-select>
            <!-- <el-input v-model="msgInfo.msg_type"></el-input> -->
          </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r x-w100">
          消息标题
        </div>
        <div class="x-flex-1">
          <el-input v-model="msgInfo.msg_title"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20 x-col-start">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r x-w100">
          消息内容
        </div>
        <div class="x-flex-1">
          <el-input v-model="msgInfo.msg_content" type="textarea"  :rows="2"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20 x-p-b-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r x-w100">
          跳转链接
        </div>
        <div class="x-flex-1">
          <el-input v-model="msgInfo.to_url"></el-input>
        </div>
        <!-- </div> -->
      </div>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: "条件查询",
        merInputVal: "",
        // uploadImgValue:'',//上传的文件名称
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        options: [{
          val: 'smSell5.0'
        }], //软件信息
        msgTypeList: [{
          val: '系统更新'
        },{
          val: '系统公告'
        }], //消息类型
        tableJson: [{
            id: 7,
            title: "消息ID",
            width: "120",
            sortType: "msg_id",
          }, {
            // 循环渲染数据
            id: 2,
            title: "软件信息",
            width: "120",
            sortType: "soft_type",
          },
          {
            id: 3,
            title: "消息类型",
            width: "180",
            sortType: "msg_type",
          },
          {
            id: 4,
            title: "消息标题",
            width: "180",
            sortType: "msg_title",
          },
          {
            id: 5,
            title: "消息内容",
            width: "260",
            sortType: "msg_content",
          },
          {
            id: 6,
            title: "跳转链接",
            width: "240",
            sortType: "to_url",
          },
          {
            id: 11,
            title: "修改人",
            width: "100",
            sortType: "modify_user_name",
          },
          {
            id: 12,
            title: "修改时间",
            width: "180",
            sortType: "modify_time",
          },

        ],
        addOrEditAgent: false, // 增加/修改用户
        msgAddOrEdit: "ADD",
        msgInfo: {
          soft_type: 'smSell5.0',
          mch_id: '',
          msg_id:'',
          msg_type: '系统更新',
          msg_title: '',
          msg_content: '',
          to_url: 'http://www.sanmipos.com',
        },


      };
    },
    created() {
      this.init();
    },
    methods: {
      async init() {
        let res = await this.fMchFaceManger({
          oper: 'MSG_LIST'
        });


        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = res.data[0].TR; //总条数
          this.TP = res.data[0].TP; //总页数
        }
        this.tableData = res.data;
      },

      async fModify(row) {
        this.msgAddOrEdit = "EDIT";
        this.fileLise = []
        this.addOrEditAgent = true;
        // let res = await this.fMchFaceManger(
        //   "GET",
        //   row.user_phone
        // );
        // console.log(row.user_phone)

        // if (res.result != "sucess") {
        //   return this.$message(res.msg);
        // }
        this.msgInfo.soft_type = row.soft_type;
        this.msgInfo.msg_type = row.msg_type;
        this.msgInfo.msg_id = row.msg_id;
        this.msgInfo.msg_title = row.msg_title;
        this.msgInfo.msg_content = row.msg_content;
        this.msgInfo.to_url = row.to_url;

      },
      async unBand(row) {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fMchFaceManger({
            oper: 'DEL',
            msg_id:row.msg_id
          })
          if (res.result != 'sucess') {
            return this.$message(res.msg)
          }
          this.$message(res.msg)
          this.init()
        }).catch(() => {});
      },
      async fSavesmAi() {
        if (this.bykApi.smCom.fSmIsEmpty(this.msgInfo.soft_type)) {
          return this.$message("请选择软件信息");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.msgInfo.msg_type)) {
          return this.$message("请输入消息类型");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.msgInfo.msg_title)) {
          return this.$message("请输入消息标题");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.msgInfo.msg_content)) {
          return this.$message("请输入消息内容");
        }
        let res = await this.fMchFaceManger({
          oper: this.msgAddOrEdit
        });
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        // if (this.msgAddOrEdit == 'ADD') {
        //   this.$message(res.msg);
        // } else {
        //   this.$message('修改成功');
        // }
        this.init();
        this.fClose();
      },
      fClose() {
        this.addOrEditAgent = false;
        this.fileLise = []
        this.msgInfo = Object.assign({
          soft_type: 'smSell5.0',
          mch_id: '',
          msg_id:'',
          msg_type: '系统更新',
          msg_title: '',
          msg_content: '',
          to_url: 'http://www.sanmipos.com',
        });
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        // console.log(this.sortType, type);
        // console.log(type, asc_desc);
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fMsgAdd() {
        this.msgAddOrEdit = "ADD";
        this.addOrEditAgent = true;
        this.fileLise = []
      },
      // 分页
      // async fCurrentChange(e) {
      //   this.nowPage = e
      //   let res = await this.fMchFaceManger('MSG_LIST')

      //   if (res.result == "sucess") {
      //     this.tableData = res.data;
      //   } else {
      //     return this.$message(res.msg);
      //   }
      // },

      // ------------- 请求 开始 --------------
      async fMchFaceManger(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["MSG_ID"] = this.msgInfo.msg_id || obj.msg_id || '';
        js["SOFT_TYPE"] = this.msgInfo.soft_type;
        js["MSG_TYPE"] = this.msgInfo.msg_type;
        js["MSG_TITLE"] = this.msgInfo.msg_title;
        js["MSG_CONTENT"] = this.msgInfo.msg_content;
        js["TO_URL"] = this.msgInfo.to_url;
        js["MODIFY_USER_NAME"] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name
        js['MCH_ID'] = obj.mch_id || this.msgInfo.mch_id
        js['READ_USER_NAME'] = ''
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi("SMSELL_MSG_MANGER", js);
        console.log(res)
        return res;
      },
      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .smAi {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/msgAdmin.vue